import { BaseButton, TopNavItem, TopNavLeft, TopNavRight } from '@enter/core';
import { mdiMessageTextOutline, mdiDockRight } from '@mdi/js';
import Icon from '@mdi/react';
import { ClaimSearchBar, CompanyButton, ProviderMessagingContext, UserButton } from 'components';
import { inject, observer } from 'mobx-react';
import React, { useContext } from 'react';
import { getRouteClaimId, getRouteGuarantorId } from 'services';
import { IInjectedRootStore } from 'stores';
import pkg from '../../../package.json';
import logoBlue from './logo_enter_blue_latest.svg';
import * as S from './main.topnav.styles';

type IMainTopnavProps = IInjectedRootStore;

export const MainTopnav: React.FunctionComponent<IMainTopnavProps> = inject('rootStore')(
    observer(
        (props: IMainTopnavProps): React.ReactElement => {
            const messagingContext = useContext(ProviderMessagingContext);
            const { rootStore } = props;
            const { layoutStore } = rootStore;
            const description = `Provider Dashboard v${pkg.version}`;

            const openMessages = () => {
                const claimId = getRouteClaimId();
                const guarantorId = getRouteGuarantorId();

                messagingContext.openPanel?.({ claimId, guarantorId });
            };

            const toggleSidebar = () => {
                const prev = layoutStore.sidebarCollapsed;
                const next = !prev;
            
                layoutStore.toggleSidebar(next);
            };

            return (
                <S.MainNav>
                    <TopNavLeft>
                        <S.LogoSection>
                            <S.Logo src={logoBlue} alt={description} title={description} />
                            <S.CollapseButton
                                variant="text"
                                onClick={toggleSidebar}
                                collapsed={layoutStore.sidebarCollapsed}>
                                <Icon
                                    path={mdiDockRight}
                                    size={0.8}
                                />
                            </S.CollapseButton>
                        </S.LogoSection>
                        <TopNavItem>
                            <S.SearchBarWrapper>
                                <ClaimSearchBar />
                            </S.SearchBarWrapper>
                        </TopNavItem>
                    </TopNavLeft>
                    <S.Spacer />
                    <TopNavRight>
                        <S.DesktopItem>
                            <CompanyButton companyName={rootStore.companyName} />
                        </S.DesktopItem>
                        <TopNavItem>
                            <BaseButton variant="fab-light" size="medium" onClick={openMessages}>
                                <S.StyledIcon path={mdiMessageTextOutline} size={1} />
                            </BaseButton>
                        </TopNavItem>
                        <TopNavItem>
                            <UserButton rootStore={rootStore} />
                        </TopNavItem>
                    </TopNavRight>
                </S.MainNav>
            );
        },
    ),
);
